import { Card, Illustration, LinkButton, Text } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface Props {
  message: string;
  canCreate: boolean;
}
export function ApplyLinkEmptyState(props: Props) {
  const { message, canCreate } = props;
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <Card>
      <div
        style={{
          display: "flex",
          gap: "var(--space-4)",
          flexDirection: "column",
          alignItems: "center",
          padding: "2rem",
        }}
      >
        <Illustration name="sparkles" />
        <Text style="global/body-secondary">{message}</Text>
        {canCreate && (
          <LinkButton
            textStyle="global/body-secondary-link"
            linkStyle="monochrome"
            testID="create-new-apply-link"
            onPress={() => navigate(`/apply-link/create`)}
          >
            {t("New apply link")}
          </LinkButton>
        )}
      </div>
    </Card>
  );
}
